import { useContext } from 'react';
import { HandHistoryContext, HandHistoryContextValue } from 'contexts/HandHistoryContext';

const noop = () => {};

// Outside a table panel (lobby, demo tables, snapshots) there is no session:
// history reads as locked and closed, and its controls do nothing.
const noHandHistory: HandHistoryContextValue = {
  data: { locked: true, completedHands: [] },
  isLoading: false,
  refresh: noop,
  demoLocked: false,
  setDemoLocked: noop,
  demoGameMode: 'cash',
  setDemoGameMode: noop,
  demoVariant: 'texas',
  setDemoVariant: noop,
  isOpen: false,
  setIsOpen: noop,
  selectedIndex: 0,
  setSelectedIndex: noop,
  revealOwnCards: noop
};

export const useHandHistory = () => useContext(HandHistoryContext) ?? noHandHistory;
